<div class="orgApp-dp-display-div">
    <div class="orgApp-duties-dp-display">
        <button mat-icon-button (click)="prevMonth()" [ngClass]="planningLoader || managerPlanningLoader ?'orgApp-dp-action-dis-btn':''"
            [disabled]="planningLoader || managerPlanningLoader" matTooltip="{{'monthPicker.tooltip.prev' | translate }}"
            matTooltipPosition="above"
            class="orgApp-dp-action-btn orgApp-duties-h-40 orgApp-d-flex orgApp-align-i-center orgApp-justify-c-center">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <use [attr.xlink:href]="planningLoader || managerPlanningLoader ? '#left-icon-grey' : '#left-icon'"></use>
            </svg>
        </button>

        <!-- Span as the overlay origin anchor -->
        <span class="orgApp-duties-dp-date-display" (click)="openMonthYearPicker(dp)"
            [ngClass]="{'orgApp-dp-data-dis-span': planningLoader || managerPlanningLoader}" #anchorSpan (keydown)="
            (!planningLoader || !managerPlanningLoader) && ($event.key === 'Enter' || $event.key === ' ') && openMonthYearPicker(dp)
            " [attr.aria-disabled]="planningLoader || managerPlanningLoader ? 'true' : null" [class.disabled]="planningLoader || managerPlanningLoader">
            {{ formattedDateDisplay }}
        </span>

        <button mat-icon-button (click)="nextMonthClick()" [disabled]="planningLoader || managerPlanningLoader"
            [ngClass]="planningLoader || managerPlanningLoader ?'orgApp-dp-action-dis-btn':''"  matTooltip="{{'monthPicker.tooltip.next' | translate }}"
            matTooltipPosition="above"
            class="orgApp-dp-action-btn orgApp-duties-h-40 orgApp-d-flex orgApp-align-i-center orgApp-justify-c-center">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <use [attr.xlink:href]="planningLoader || managerPlanningLoader ? '#right-icon-grey' : '#right-icon'"></use>
            </svg>
        </button>
    </div>
    <mat-form-field class="orgApp-duties-hidden-dp">
        <input matInput [matDatepicker]="dp" [formControl]="date" style="display: none" [value]="currentMonth" />
        <mat-hint>MM/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="dp" class="orgApp-duties-dp-hidden-toggle"></mat-datepicker-toggle>
        <mat-datepicker #dp startView="year" (monthSelected)="setMonthAndYear($event, dp,'calendar-sel')"
            panelClass="orgApp-duties-dp-calendar">
        </mat-datepicker>
    </mat-form-field>
</div>